import { render, staticRenderFns } from "./AgentChatItem.vue?vue&type=template&id=a8aa22da&scoped=true&"
import script from "./AgentChatItem.vue?vue&type=script&lang=js&"
export * from "./AgentChatItem.vue?vue&type=script&lang=js&"
import style0 from "./AgentChatItem.vue?vue&type=style&index=0&id=a8aa22da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8aa22da",
  null
  
)

export default component.exports